module.exports = __webpack_public_path__ + "static/media/Photo22.4ac9f1a7.jpg";